import { render, staticRenderFns } from "./brandSummary.vue?vue&type=template&id=555761f8&scoped=true"
import script from "./brandSummary.vue?vue&type=script&lang=js"
export * from "./brandSummary.vue?vue&type=script&lang=js"
import style0 from "./brandSummary.vue?vue&type=style&index=0&id=555761f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555761f8",
  null
  
)

export default component.exports